import state from '~store/modules/users/state'
import actions from '~store/modules/users/actions'
import getters from '~store/modules/users/getters'

export default {
  state,
  actions,
  getters
}
